module.exports = __webpack_public_path__ + "img/brighttree.aadb9d48.png";